export * from '@hotelplan/platform-graphql-api';
